<div class="wrapper">
  <app-header></app-header>

  <div class="container">
    <div class="h-100 p-relative overflow-auto">
      <div class="px-3 py-2 overflow-scroll">
        <div *ngIf="step?.showIntro">
          <h1 class="text-black" style="font-size: 24px">
            {{ translate('fix_label') }}
          </h1>
          <p>{{ translate('info_text') }}</p>
          <p>{{ translate('step_message') }}</p>
        </div>

        <div *ngIf="!step?.showIntro && step?.steps?.length" class="show-intro">
          {{ translate(step.steps[0]?.optionsLabelKey) }}
        </div>

        <div *ngIf="step?.machineIssueListItems">
          <div class="progress-container">
            <div class="progress-bar">
              <div
                *ngFor="let item of machineIssueList"
                class="progress-fill"
                [style.width.%]="progress"
                [ngClass]="{ inactive: !item.answered }"
              ></div>
            </div>
            <div class="progress-segment">
              {{ progress | number: '1.0-0' }}%
            </div>
          </div>

          <h4 class="show-intro" *ngIf="machineIssueList.length">
            {{ translate('check_machine') }}
          </h4>

          <div
            *ngFor="let question of machineIssueList; let i = index"
            class="check-item"
          >
            <div class="result-content">
              <div class="sub-content">
                <div
                  class="status-indicator"
                  *ngIf="!question.answered; else done"
                >
                  <div class="circle"></div>
                </div>

                <ng-template #done>
                  <div class="ticks">
                    <i class="fas fa-check"></i>
                  </div>
                </ng-template>

                <div class="content-list">
                  {{ translate(question.titleKey) }}
                </div>
              </div>

              <div
                *ngIf="question.detailKeys?.length"
                class="accordion-icon"
                (click)="toggleAccordion(i)"
              >
                <i
                  [ngClass]="
                    question.expanded
                      ? 'fas fa-chevron-up'
                      : 'fas fa-chevron-down'
                  "
                ></i>
              </div>
            </div>

            <div class="accordion-content" *ngIf="question.expanded">
              <div *ngFor="let key of question.detailKeys">
                <p>{{ translate(key) }}</p>
              </div>
            </div>

            <div class="actions">
              <button
                class="ok-btn"
                [class.selectedOk]="question.status === 'ok'"
                [class.inactive]="question.status === 'issue'"
                (click)="answer(i, 'ok'); question.expanded = false"
              >
                <div *ngIf="question.status === 'ok'" class="tick">
                  <i class="fas fa-check"></i>
                </div>
                <div>{{ translate('ok') }}</div>
              </button>

              <button
                class="issue-btn"
                [class.selectedIssue]="question.status === 'issue'"
                [class.inactive]="question.status === 'ok'"
                (click)="answer(i, 'issue'); question.expanded = false"
              >
                <div *ngIf="question.status === 'issue'" class="tick-issue">
                  <i class="fas fa-check"></i>
                </div>
                <div>{{ translate('issue') }}</div>
              </button>
            </div>
          </div>

          <div class="button-group">
            <button class="help-btn" (click)="resolved()">
              {{ translate('resolved') }}
            </button>

            <button class="btn-blue-outline ms-1" (click)="needHelp()">
              <img class="chatIcon" src="assets/images/icon/chat.png" />
              <span>{{ translate('need_help') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
